import CustomAsyncSelect from "../CustomAsyncSelect";

const ProductTagSelect = ({
    label,
    description,
    placeholder = "Search and select tags...",
    value = [],
    onChange,
    name = "productTags",
    className,
    containerClass,
    ...props
}) => {
    // Transform API data to select options
    const transformData = (tag) => ({
        value: tag.id,
        label: tag.name,
        count: tag.count,
    });

    // Format option label with tag ID and product count
    const formatOptionLabel = (option) => (
        <div className="flex items-center justify-between w-full py-[0.20rem]">
            <div className="flex items-center gap-2 flex-1 min-w-0">
                <span className="text-xs font-medium text-gray-500 flex-shrink-0">
                    #{option.value}
                </span>
                <span className="text-sm text-gray-900 truncate">
                    {option.label}
                </span>
            </div>
            {option.count !== undefined && (
                <span className="text-xs text-gray-500 ml-3 flex-shrink-0">
                    {option.count} {option.count === 1 ? "item" : "items"}
                </span>
            )}
        </div>
    );

    return (
        <CustomAsyncSelect
            label={label}
            value={value}
            onChange={onChange}
            name={name}
            placeholder={placeholder}
            description={description}
            className={className}
            containerClass={containerClass}
            endpoint="wc/v3/products/tags"
            transformData={transformData}
            formatOptionLabel={formatOptionLabel}
            searchParams={{
                orderby: "name",
                order: "asc",
                hide_empty: "false",
            }}
            selectedLabel="Tag"
            noOptionsText="Start typing to search tags..."
            {...props}
        />
    );
};

export default ProductTagSelect;
